export const STOCK_ADJUSTMENT_DOCUMENT_DROP_DOWN_ITEMS = [
    {
        id: "stock-adjustments",
        text: "stock adjustment"
    },
]